import { useEffect, useState } from 'react'

export function useOrigin() {
  const [localOrigin, setLocalOrigin] = useState<string>(
    typeof window === 'undefined' ? '' : window.location.origin,
  )

  useEffect(() => {
    setLocalOrigin(window.location.origin)
  }, [])
  return localOrigin
}
